export function gtag_event(event, value, label) {
    label = label || event;

    if (!window.gtag) {
        window.gtag = function() { window.dataLayer.push(arguments); };
        gtag('js', new Date());
        gtag('config', 'GTM-5474V97');
    }

    window.gtag('event', 'Konfigurator', {
        'event_category': 'Zielvorhaben',
        'event_label': label,
        'value': value || '',
    });
}



// WEBPACK FOOTER //
// ./src/gtag.js